<template>
    <div>
        <v-container justify-start pb-0>
            <v-layout
                v-bind="{
                    column: $vuetify.breakpoint.xsOnly,
                    row: $vuetify.breakpoint.smAndUp
                }"
                wrap
                align-content-start
                justify-start
            >
                <v-flex shrink>
                    <div class="title mb-2 mr-2">Matches</div>
                </v-flex>
                <v-divider vertical class="hidden-xs-only mr-2"></v-divider>
                <v-flex align-self-start>
                    <v-breadcrumbs divider=">" style="display:inline; padding-left: 0;">
                        <v-breadcrumbs-item style to="/admin" v-bind:exact="exact">Administration</v-breadcrumbs-item>
                        <v-breadcrumbs-item style to="/admin/matches" v-bind:exact="exact">Matches</v-breadcrumbs-item>
                    </v-breadcrumbs>
                </v-flex>
            </v-layout>
            <v-divider></v-divider>
            <v-layout
                v-bind="{
                    column: $vuetify.breakpoint.xsOnly,
                    row: $vuetify.breakpoint.smAndUp
                }"
                wrap
                align-content-start
                justify-start
            >
                <v-flex xs12 sm3>
                    <v-btn
                        flat
                        small
                        color="primary"
                        class="mb-3 mt-3"
                        to="/admin/matches/new"
                        right
                    >New Match</v-btn>
                </v-flex>
                <v-flex xs12 offset-sm6 sm3>
                    <v-select v-model="selectedTeamId" v-bind:items="teams" label="Team"></v-select>
                </v-flex>
            </v-layout>
        </v-container>
        <v-container pt-0>
            <v-tabs v-model="tab" v-bind:value="tab">
                <v-tab>
                    Incomplete Matches
                </v-tab>
                <v-tab>
                    Completed Matches
                </v-tab>
            </v-tabs>
            <v-tabs-items v-model="tab">
                <v-tab-item>
                    <matches-grid v-bind:groupedMatches="groupedIncompleteMatches" admin="admin"></matches-grid>
                </v-tab-item>
                <v-tab-item>
                    <matches-grid v-bind:groupedMatches="groupedCompletedMatches" admin="admin"></matches-grid>
                </v-tab-item>
            </v-tabs-items>
        </v-container>
    </div>
</template>

<script>
import MatchesGrid from './MatchesGrid.vue'

export default {
    name: 'AdminMatches',
    data() {
        return {
            tab: 0,
            exact: true,
            selectedTeamId: 'All',
            admin: true
        }
    },
    computed: {
        incompleteMatches() {
            if (this.selectedTeamId === 'All') {
                return this.$store.getters.getIncompleteMatches
            } else {
                return this.$store.getters.getIncompleteMatches.filter((m) => {
                    if (m.away_team_id === this.selectedTeamId) {
                        return true
                    } else if (m.home_team_id === this.selectedTeamId) {
                        return true
                    } else {
                        return false
                    }
                })
            }
        },
        completedMatches() {
            if (this.selectedTeamId === 'All') {
                return this.$store.getters.getCompletedMatches
            } else {
                return this.$store.getters.getCompletedMatches.filter((m) => {
                    if (m.away_team_id === this.selectedTeamId) {
                        return true
                    } else if (m.home_team_id === this.selectedTeamId) {
                        return true
                    } else {
                        return false
                    }
                })
            }
        },
        groupedIncompleteMatches() {
            return this.groupMatchesByDate(this.incompleteMatches)
        },
        groupedCompletedMatches() {
            return this.groupMatchesByDate(this.completedMatches)
        },
        teams() {
            let teamNames = this.$store.getters.getMatchTeams
                .map((team) => {
                    return { text: team.team, value: team.id }
                })
                .sort((a, b) => {
                    if (a.text > b.text) {
                        return 1
                    } else if (a.text < b.text) {
                        return -1
                    } else {
                        return 0
                    }
                })

            teamNames.unshift({ text: 'All', value: 'All' })

            return teamNames
        }
    },
    methods: {
        groupMatchesByDate(matches) {
            const grouped = {}
            matches.forEach(match => {
                const date = match.match_moment.format('ddd MMM D')
                if (!grouped[date]) {
                    grouped[date] = []
                }
                grouped[date].push(match)
            })
            return grouped
        }
    },
    components: {
        MatchesGrid
    }
}
</script>

<style scoped></style>
